import { render, staticRenderFns } from "./announcementsForm.vue?vue&type=template&id=2ddffa62"
import script from "./announcementsForm.vue?vue&type=script&lang=js"
export * from "./announcementsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports